
import {  GET_ALL_USERS_ERROR, GET_ALL_USERS_SUCCESS, GET_ALL_USERS_POST_ERROR ,NEW_USER_SUCCESS} from "../actions/types";

export default (state = {  
    error: null,
    listUser:[],
    new:{},
    success:false,
}, action) => {
    switch (action.type) {
        case GET_ALL_USERS_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: action.payload.message,
            };
            break;
        case GET_ALL_USERS_SUCCESS:
            return {
                ...state,
                error: state.error,
                loading:false,
                listUser: action.payload,
                success:true,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve User Successfully',
            };
            break;
            case NEW_USER_SUCCESS:
                return {
                    ...state,
                    error: state.error,
                    loading:false, 
                    success:true,
                    new:action.payload,
                    isSnackbarError: false,
                    isSwitchSnackbarOn: true,
                    ErrorMessage: 'New Users Added Successfully',
                };
                break;
            
        case GET_ALL_USERS_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Retrieve Error | ' + state.error,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/concessionUserReducer.js